import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class DasDataServiceService {
  public applicationId:number;
  public acronym: string;
  public taskName:string;
  public formView:string;
  public statusId:number;
  public statusCodeId;
  public appData:BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() { }
  public setApplicationId(id,acronym,formView?,taskName?,statusCodeId?){
    this.applicationId = id;
    this.acronym = acronym;
    this.taskName = taskName;
    this.formView = formView;
    this.statusId = statusCodeId;
  }

  setAppData(id,acronym,formView?,taskName?,statusCodeId?) {
    this.appData.next({ applicationId: id, acronym:acronym, taskName:taskName,formView:formView, statusId:statusCodeId });
  }


  getAppData(): Observable<any> {
    return this.appData.asObservable();
  }
}
